import request from '@/utils/request'
// 上传和删除商品图片信息的接口
export const uploadImages = (formData) => {
  return request.post('/file/images', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteImage = (image, goodsId) => {
  return request.delete('/file/image', {
    params: {
      image,
      goodsId
    }
  })
}
// 上传和删除gossip图片接口
export const uploadGossipImages = (formData) => {
  return request.post('/file/gossip', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteGossipImage = (image, gossipId) => {
  return request.delete('/file/gossip', {
    params: {
      image,
      gossipId
    }
  })
}

// 上传和删除rent图片接口
export const uploadRentImages = (formData) => {
  return request.post('/file/rent', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteRentImage = (image, rentId) => {
  return request.delete('/file/rent', {
    params: {
      image,
      rentId
    }
  })
}

// 上传和删除rent图片接口
export const uploadGameDataFile = (formData) => {
  return request.post('/file/gameData', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteGameDataFile = (file, gameDataId) => {
  return request.delete('/file/gameData', {
    params: {
      file,
      gameDataId
    }
  })
}

// 上传和删除商会图片接口
export const uploadCommercialMemberFile = (formData) => {
  return request.post('/file/commercialMember', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteCommercialMemberFile = (image, commercialMemberId) => {
  return request.delete('/file/commercialMember', {
    params: {
      image,
      commercialMemberId
    }
  })
}

// 上传和删除商会商标图片接口
export const uploadCommercialMemberAvatar = (formData) => {
  return request.post('/file/commercialMemberAvatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteCommercialMemberAvatar = (file, commercialMemberId) => {
  return request.delete('/file/commercialMemberAvatar', {
    params: {
      file,
      commercialMemberId
    }
  })
}

// 上传和删除外观图片接口
export const uploadOutfitFile = (formData) => {
  return request.post('/file/outfit', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteOutfitFile = (image, outfitId) => {
  return request.delete('/file/outfit', {
    params: {
      image,
      outfitId
    }
  })
}
// 上传和删除用户头像接口
export const uploadUserAvatar = (formData) => {
  return request.post('/file/user/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const deleteUserAvatar = (file, id) => {
  return request.delete('/file/user/avatar', {
    params: {
      file,
      id
    }
  })
}
